import { render, staticRenderFns } from "./editBasic.vue?vue&type=template&id=26a9c182"
import script from "./editBasic.vue?vue&type=script&lang=js"
export * from "./editBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports